import { FilterMatchMode } from "primereact/api"

export class AreaNegocio {

    model = {
        id: {
            value: null, header: 'Código', export: true, table: false,
        },
        tipo_negocio: {
            value: null, export: true, header: 'Área negocio', required: 'Area Negocio es requerido', table: true,
            filterField: 'tipo_negocio', filter: true, sort: true, matchMode: FilterMatchMode.CONTAINS,
            headerStyle: { width: '30%', minWidth: '20rem' }
        },
        plantilla: {
            value: null, export: true, header: 'Plantilla', required: 'Plantilla es requerido', table: true,
            filterField: 'plantilla', filter: true, sort: true, matchMode: FilterMatchMode.CONTAINS,
            headerStyle: { width: '30%', minWidth: '20rem' }
        },
        factor: {
            value: null, export: true, header: 'Factor', required: 'Factor es requerido', table: false,
            filterField: 'factor', filter: true, sort: true, matchMode: FilterMatchMode.CONTAINS,
            headerStyle: { width: '30%', minWidth: '20rem' }
        },
        orden: {
            value: 0, export: true, header: 'orden', required: 'Orden es requerido', maxLength: 'Máximo 100', table: true,
            minLength: 'Mínimo 1', max: 100, min: 1
        },
        valor: { header: 'Valor', value: null, required: 'Valor es requerido', optionLabel: 'valor', table: true },
        formula: {
            value: '', export: true, header: 'Fórmula', required: false, table: false,
            filterField: 'formula', filter: false
        },
    }
    optionLabel = 'nombre'
}
